<div
  class="date-range-control"
  [nbTooltip]="retentionTooltip"
  [nbTooltipDisabled]="!anyRangeDisabled"
>
  <nb-button-group (valueChange)="onDateRangeSelect($event)">
    <button
      [pressed]="dateRange === 7"
      nbButtonToggle
      [value]="7"
      [disabled]="isRangeDisabled(7)"
    >
      7d
    </button>
    <button
      [pressed]="dateRange === 30"
      nbButtonToggle
      [value]="30"
      [disabled]="isRangeDisabled(30)"
    >
      1M
    </button>
    <button
      [pressed]="dateRange === 90"
      nbButtonToggle
      [value]="90"
      [disabled]="isRangeDisabled(90)"
    >
      3M
    </button>
    <button
      [pressed]="dateRange === 365"
      nbButtonToggle
      [value]="365"
      [disabled]="isRangeDisabled(365)"
    >
      1Y
    </button>
  </nb-button-group>
</div>
